/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import store from '../../redux/store';
import { availableTenants, getCurrentTenant, getCurrentPermissions } from '../../redux/modules/userData/selectors';

const Wrapper = styled.div`
  border: none;
  height: 95vh;
`;

const Frame = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
`;

class Wfm extends Component {
  constructor(props) {
    super(props);
    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    removeEventListener('message', this.handleMessage);
  }

  handleMessage = event => {
    if (event.data || event.data.module || event.data.module === 'updateLocalStorage') {
      event.source.postMessage(
        {
          error: null,
          topic: ['updateLocalStorage'],
          response: {
            tenant: getCurrentTenant(store.getState()),
            tenants: availableTenants(store.getState()),
            platformPermissions: getCurrentPermissions(store.getState()),
            agentId: CxEngage.session.getActiveUserId(),
            token: CxEngage.dumpState().authentication.token,
            baseUrl: `https://${localStorage.getItem('ENV')}-api.cxengagelabs.net`
          },
          messageId: event.data.messageId
        },
        '*'
      );
    }
  };

  render() {
    const wfmUrl = localStorage.getItem('wfm') + '#/' + this.props.match.params.wfmPage;
    return (
      <Wrapper>
        <Frame
          id='wfmContainer'
          key='wfmContainer'
          src={wfmUrl}
        />
      </Wrapper>
    );
  }
}

export default injectIntl(Wfm);

Wfm.propTypes = {
  pageTitle: PropTypes.string,
  pageHelpLink: PropTypes.string,
  intl: PropTypes.object.isRequired,
};
